import Status from 'clarks/components/ivu-table/status'

let forms = {
   attach_dashboard: {
      icon: 'fa fa-university',
      title: 'Dashboard',
      subtitle: 'Attach Dashboard',
      forms: [
         {
            type: 'select', class: 'col-12', model: 'dashboard',
            options: [], validation: '', label: 'Dashboard'
         },
      ]
   },
}

let tables = {
   table: {
      props: {
         icon: 'fa fa-bullhorn',
         title: 'Events',
         border: true,
         'max-height': 600,
         'show-summary': false,
         search_fields: ['alias', 'name', ],
         columns: [
            { type: 'selection', width: 60, align: 'center' },
            { type: 'index', width: 100, align: 'center' },
            { title: "Name", key: "name", min_width: 200},
            { title: "Alias", key: "alias", min_width: 200 },
            { title: "Total Events", key: "record_count", align: 'center', width: 200 },
            {
               title: "Status",
               key: "status",
               align: 'center',
               width: 180,
               render: (h, params) => {
                  return h(Status, {
                     props: {
                        status: params.row.status
                     }
                  });
               },
               filters: [{
                     label: "Created",
                     value: 1
                  },
                  {
                     label: "Updated",
                     value: 2
                  },
                  {
                     label: "Pending Create Verification",
                     value: 3
                  },
                  {
                     label: "Pending Update Verification",
                     value: 4
                  },
                  {
                     label: "Pending Delete Verification",
                     value: 5
                  }
               ],
               filterMultiple: true,
               filterMethod(value, row) {
                  switch (value) {
                     case 1:
                        return row.status === 'created';
                     case 2:
                        return row.status === 'updated';
                     case 3:
                        return row.status === 'create_pending';
                     case 4:
                        return row.status === 'update_pending';
                     case 5:
                        return row.status === 'delete_pending';
                  }
               }
            },
         ],
         actions: [
            { type: 'menu', title: 'View', event: 'view', allow_multiple: false },
            { type: 'menu', title: 'Update Dashboard', event: 'table:attach_dashboard', icon:'fa-project-diagram', allow_multiple: false },
            { type: 'menu', title: 'View Dashboard', event: 'table:view_dashboard', icon:'fa-chart-area', allow_multiple: false },
         ]
      },
   },
}

export default {
   forms: utils.generateAllFormData(forms),
   tables
}